import {ChangeDetectionStrategy, Component, input, output} from '@angular/core';
import {
    BigintDeliverableDisplayDecimalPipe
} from '../../../components/bigint-display-decimal-pipe/bigint-deliverable-display-decimal.pipe';
import {ComputedTranche} from '../../../components/dex/dex-streaming/types/computed/computed-tranche';
import {DisplayDecimalModule} from '../../../components/display-decimal';
import {Side} from '../../../enums/side';
import {SparklineModule} from '../../../mobile/pages/m-quotes-page/m-quotes-mini-chart/sparkline';

@Component({
    selector:        'dex-tranche-actions',
    templateUrl:     './dex-tranche-actions.component.html',
    styleUrl:        './dex-tranche-actions.component.scss',
    imports: [
        SparklineModule,
        DisplayDecimalModule,
        BigintDeliverableDisplayDecimalPipe
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class DexTrancheActionsComponent {

    public readonly tranche = input.required<ComputedTranche>();
    public readonly tradeClick = output<Side>();

    public readonly Side = Side;

    public onTradeClick(side: Side, event: MouseEvent): void {
        event.preventDefault();
        event.stopPropagation();

        this.tradeClick.emit(side);
    }

}
